import auth from '@app/slices/auth';
import global from '@app/slices/global';
import admin from '@admin/reducers';
import pageTitle from '@app/slices/page-title';
import saga from '@app/slices/saga';

export default {
  auth,
  global,
  admin,
  pageTitle,
  saga,
};
